module.exports = __webpack_public_path__ + "img/backgroundIndex.dd1854e3.png";